import { SpinePlayer } from '@slot-nx/core'
import { tableService } from '../domain/table/tableService'
import { useEffect, useRef } from 'react'
import { Container } from '@pixi/react'
import { Container as PixiContainer } from 'pixi.js'

interface TableProps {
  x: number
  y: number
}

export const Table = (props: TableProps) => {
  const potContainerRef = useRef<PixiContainer>(null)

  useEffect(() => {
    if (potContainerRef.current) {
      tableService.setPotContainer(potContainerRef.current)
    }
  }, [])

  return (
    <Container>
      <SpinePlayer
        name="table_spine"
        onCreatedSpine={spine => (tableService.setTableSpine = spine)}
        playOnLoad={true}
        data="table.skel"
        atlas="table.atlas"
        x={props.x}
        y={props.y}
        animationStr="main"
        loop={true}
      />
      <Container name="PotsContainer" x={props.x} y={props.y - 50} ref={potContainerRef} />
    </Container>
  )
}
